import DocumentVerificationNegativeBanner from './DocumentVerificationNegativeBanner';

export default DocumentVerificationNegativeBanner;
